import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';

import QuickSearch from '../../search/QuickSearch';

const messages = defineMessages({
  filterList: {
    id: 'productListFilter.filterList',
    defaultMessage: 'Filter list'
  }
});

@observer
export class ProductListFilter extends Component {
  render() {
    const {
      configStore,
      onProductListFiltering,
      clearProductListFilter,
      searchTerm,
      intl
    } = this.props;

    if (!configStore.productListFilter.enabled) {
      return null;
    }

    const placeholder = intl.formatMessage(messages.filterList);

    const productListFilterButtonText = (
      <FormattedMessage
        id="productListFilter.filter"
        defaultMessage="Filter by keyword"
      />
    );

    return (
      <div className="ProductListFilter">
        <QuickSearch
          handleFocus={() => null}
          handleBlur={() => null}
          toggleSearch={() => null}
          productListFilter
          onProductListFiltering={onProductListFiltering}
          clearProductListFilter={clearProductListFilter}
          searchTerm={searchTerm}
          placeholder={placeholder}
          buttonText={productListFilterButtonText}
          quickSearchId="ProductListFilter__Autosuggest"
        />
      </div>
    );
  }
}

ProductListFilter.propTypes = {
  onProductListFiltering: PropTypes.func,
  clearProductListFilter: PropTypes.func,
  searchTerm: PropTypes.string
};

export default inject(
  'categoryStore',
  'configStore',
  'sectionStore',
  'uiStore'
)(injectIntl(ProductListFilter));



// WEBPACK FOOTER //
// ./src/components/product-list/ProductListFilter/index.jsx